import React                from 'react';
import PropTypes            from 'prop-types';
import EmailRecipientSelect from '~/components/forms/dropdowns/EmailRecipientSelect';

const EmailRecipientField = ({
  type,
  value,
  onChange,
  onHide,
}) => (
  <div className="form-group mb15">
    <a href="#cancel" className="pull-right" onClick={onHide}>
      Cancel and hide
    </a>
    <label htmlFor={`${type}-email-address`} className="d-block">
      {type.toUpperCase()}
    </label>
    <EmailRecipientSelect
      id={`${type}-email-address`}
      name={`${type}-address`}
      type={type}
      value={value}
      onChange={onChange}
    />
  </div>
);

EmailRecipientField.defaultProps = {
  value: [],
};

EmailRecipientField.propTypes = {
  type:     PropTypes.oneOf(['cc', 'bcc']).isRequired,
  value:    PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  onHide:   PropTypes.func.isRequired,
};

export default EmailRecipientField;
